import { render, staticRenderFns } from "./KeywordSearch.vue?vue&type=template&id=4df825ca&scoped=true"
import script from "./KeywordSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./KeywordSearch.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df825ca",
  null
  
)

export default component.exports